import {
    FETCH_WALLET_TRANSACTIONS_REQUEST,
    FETCH_WALLET_TRANSACTIONS_SUCCESS,
    FETCH_WALLET_TRANSACTIONS_FAILURE,
} from "../actions/types";

const initialState = {
    walletTransactions: {
        data: [],
        total: 0,
        page: 1,
        size: 10,
        pages: 0,
    },
    loading: false,
    error: null,
};

export default function walletTransactionReducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case FETCH_WALLET_TRANSACTIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_WALLET_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                walletTransactions:
                    action.payload,
            };

        case FETCH_WALLET_TRANSACTIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
}